<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import StepsBreadcrumbs from '@/components/StepsBreadcrumbs.vue';
import TheStepsHeader from '@/components/TheStepsHeader.vue';
import { useSubscribeStore } from '@/store/subscribe';

const subscribeStore = useSubscribeStore();
const currentStepIndex = computed(() => subscribeStore.currentStepIndex);

const mainRef = ref<HTMLElement>();

watch(currentStepIndex, () => {
	window.scrollTo(0, 0);
});
</script>

<template>
	<div>
		<TheStepsHeader>
			<StepsBreadcrumbs
				class="hidden tablet:flex absolute inset-x-0"
			/>
		</TheStepsHeader>
		<div class="border-y py-3 block tablet:hidden fixed left-0 top-12 bg-white z-90 w-full">
			<StepsBreadcrumbs />
		</div>
		<div
			ref="mainRef"
			class="pt-40 tablet:pt-36 pb-16"
		>
			<transition
				name="fade"
				mode="out-in"
			>
				<slot />
			</transition>
		</div>
	</div>
</template>
